/**
 * Performance increase module (cache, device optimizations)
 *
 * @namespace APP
 * @name APP.Performance
 */

APP.Performance = (/** @lends APP.Performance */function () {
	'use strict';

	var exports,
		$cachedDOM,
		windowResize,
		deviceProperties;

	/**
	 * Init performance helpers
	 *
	 * @inner
	 * @public
	 * @memberof APP.Performance
	 * @throws {ReferenceError} throws error if one of the methods fails
	 * @returns {void}
	 */
	function init() {
		try {
			window.$element = $element;
			initCacheDOM();
			initBindings();
			saveDeviceProperties();
		} catch (e) {
			throw new ReferenceError('APP.Performance cannot be initialized!');
		}
	}

	/**
	 * Cache DOM elements<br>
	 * The cached elements can be used in other modules by calling<br>
	 * the public method [getCachedDOM]{@link #APP.Performance.getCachedDOM}.
	 *
	 * @example
	 * var $body = APP.Performance.getCachedDOM().$body;
	 *
	 * @inner
	 * @public
	 * @memberof APP.Performance
	 * @returns {void}
	 */
	function initCacheDOM() {

		$cachedDOM = {
			window: window,
			$window: $(window),
			$body: $(document.body),
			$html: $('html'),
			$head: $('head')
		};

	}

	/**
	 * Initialize event bindings<br>
	 * Call [resizeWindow]{@link #APP.Performance.resizeWindow} on windows resize and refresh device properties
	 *
	 * @inner
	 * @memberof APP.Performance
	 * @returns {void}
	 */
	function initBindings() {
		$cachedDOM.$window.on('resize', resizeWindow);
	}

	/**
	 * Window resize hook<br>
	 * The hook is debounced to keep the performance high
	 *
	 * @inner
	 * @memberof APP.Performance
	 * @returns {void}
	 */
	function resizeWindow() {
		clearTimeout(windowResize);

		windowResize = setTimeout(function () {
			saveDeviceProperties();
		}, 200);

	}

	/**
	 * Save device properties to an object<br>
	 * Access these properties from other modules by calling [getDeviceProperties]{@link #APP.Performance.getDeviceProperties}.
	 *
	 * @example
	 * var pixelRatio = APP.Performance.getDeviceProperties().pixelRatio;
	 *
	 * @inner
	 * @memberof APP.Performance
	 * @returns {void}
	 */
	function saveDeviceProperties() {
		var w = window,
			d = document,
			e = d.documentElement,
			g = d.getElementsByTagName('body')[0],
			W = w.innerWidth || e.clientWidth || g.clientWidth,
			H = w.innerHeight || e.clientHeight || g.clientHeight;

		deviceProperties = {
			connection: navigator.connection ? navigator.connection : 'unknown',
			pixelRatio: window.devicePixelRatio,
			window: {
				width: W,
				height: H
			}
		};

	}

	/**
	 * Return cached DOM elements
	 *
	 * @example
	 * var $body = APP.Performance.getCachedDOM().$body;
	 *
	 * @inner
	 * @public
	 * @memberof APP.Performance
	 * @returns {*} - return the cached DOM elements
	 */
	function getCachedDOM() {
		return $cachedDOM;
	}

	/**
	 * Return saved device properties
	 *
	 * @example
	 * var pixelRatio = APP.Performance.getDeviceProperties().pixelRatio;
	 *
	 * @inner
	 * @public
	 * @memberof APP.Performance
	 * @returns {*} - return the set device properties
	 */
	function getDeviceProperties() {
		return deviceProperties;
	}

	function $element(name, $wrapper) {
		return ($wrapper || $cachedDOM.$body).find('[data-element="' + name + '"]');
	}

	exports = {
		init: init,
		initCacheDOM: initCacheDOM,
		getCachedDOM: getCachedDOM,
		getDeviceProperties: getDeviceProperties
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {
		init: init,
		initCacheDOM: initCacheDOM,
		saveDeviceProperties: saveDeviceProperties,
		getCachedDOM: getCachedDOM,
		getDeviceProperties: getDeviceProperties
	};

	/* end-test-code */

	return exports;

}());
